import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { PoolSupplierAutocompleteList } from '../autocomplete-list/supplier-autocomplete-list/pool-supplier-autocomplete-list';
import { Supplier } from '../../models/supplier';

export const SupplierFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (supplier: Supplier | null) => {
        filter.delete('supplierAccountId');
        if (supplier) {
            updateCache(`supplierAccount_${supplier.id}`, supplier?.name);
            filter.set('supplierAccountId', supplier.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (customerId: unknown): string => {
        if (typeof customerId !== 'string') {
            return '';
        }

        return getFromCache(`supplierAccount_${customerId}`) as string;
    };

    registerFilterMap('supplierAccountId', getDisplayValue);

    return (
        <PoolSupplierAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.filter.supplierAccount" />}
            required={false}
            initialValue={getDisplayValue(filter.get('supplierAccountId')) ?? ''}
            disablePreventOverflow={true}
        />
    );
};
